import React, { useEffect } from 'react';
import './SuccessModal.css';

/**
 * Zentrales Erfolgs-/Hinweis-Modal im CI-Stil — Ersatz für window.alert().
 *
 * Props:
 *  - message:  Text der Meldung; falsy = Modal nicht sichtbar
 *  - onClose:  wird beim Schließen aufgerufen (Button, Overlay-Klick, Escape)
 *  - children: optionale zusätzliche Aktions-Buttons neben "Schließen"
 */
function SuccessModal({ message, onClose, children }) {
  useEffect(() => {
    if (!message) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className="km-modal-overlay" onClick={onClose}>
      <div
        className="km-modal"
        role="dialog"
        aria-modal="true"
        aria-label={message}
        onClick={(e) => e.stopPropagation()}
      >
        <span className="material-symbols-outlined km-modal-icon" aria-hidden="true">check_circle</span>
        <p className="km-modal-message">{message}</p>
        <div className="km-modal-buttons">
          <button type="button" onClick={onClose} autoFocus>Schließen</button>
          {children}
        </div>
      </div>
    </div>
  );
}

export default SuccessModal;
